// extracted by mini-css-extract-plugin
module.exports = {"zoomControl":"MapZoomControl--zoomControl"};